import React, { useState } from 'react';
import { bookContent } from './data/bookContent';
import { BookCover } from './components/BookCover';
import { TableOfContents } from './components/TableOfContents';
import { ChapterView } from './components/ChapterView';
import { Footer } from './components/Footer';
type ViewMode = 'cover' | 'toc' | 'chapter';
export function App() {
  const [view, setView] = useState<ViewMode>('cover');
  const [currentChapterIndex, setCurrentChapterIndex] = useState(0);
  const handleStart = () => {
    setView('toc');
  };
  const handleSelectChapter = (index: number) => {
    setCurrentChapterIndex(index);
    setView('chapter');
  };
  const handleNextChapter = () => {
    if (currentChapterIndex < bookContent.chapters.length - 1) {
      setCurrentChapterIndex(prev => prev + 1);
      window.scrollTo(0, 0);
    } else {
      setView('toc');
    }
  };
  const handlePrevChapter = () => {
    if (currentChapterIndex > 0) {
      setCurrentChapterIndex(prev => prev - 1);
      window.scrollTo(0, 0);
    }
  };
  const handleBackToToc = () => {
    setView('toc');
  };
  const handleBackToCover = () => {
    setView('cover');
  };
  const handleReadIntro = () => {
    setCurrentChapterIndex(0);
    setView('chapter');
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-stone-50 font-sans text-stone-900 selection:bg-amber-200 selection:text-amber-900" data-id="element-0">
      {view === 'cover' && <BookCover book={bookContent} onStart={handleStart} onReadIntro={handleReadIntro} data-id="element-1" />}

      {view === 'toc' && <TableOfContents book={bookContent} onSelectChapter={handleSelectChapter} onBack={handleBackToCover} data-id="element-2" />}

      {view === 'chapter' && <ChapterView chapter={bookContent.chapters[currentChapterIndex]} currentChapterIndex={currentChapterIndex} totalChapters={bookContent.chapters.length} onNext={handleNextChapter} onPrev={handlePrevChapter} onToC={handleBackToToc} data-id="element-3" />}

      {view !== 'cover' && <Footer data-id="element-4" />}
    </div>;
}